export enum GuidedTourStep {
  Back = 'back',
  Cancel = 'cancel',
  Next = 'next',
  Complete = 'complete',
}
